"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVars = exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _createSelectOverrides = _interopRequireDefault(require("./createSelectOverrides"));
var _Select = require("./Select.util");
var _Checkbox = _interopRequireDefault(require("../../components/Checkbox"));
var _Select2 = _interopRequireWildcard(require("../../components/Select/Select.styles"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _ThemeProviderWrapper = _interopRequireDefault(require("../../ThemeProvider/ThemeProviderWrapper"));
var _Theme = require("../../themes/Theme");
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _splitCommonFromProps12 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _warning = _interopRequireDefault(require("../../utils/warning"));
var _excluded = ["children"],
  _excluded2 = ["overrides", "options", "value", "defaultValue", "isMulti", "isSearchable", "hasCheckbox", "isDisabled", "button", "labelText", "errorText", "isSelectionVisible", "id", "className", "isAsync", "hint", "description", "name", "isClearable", "size", "labelFontSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var selectCommon = ["width"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var selectVars = exports.selectVars = (0, _initVars.default)({
  applied: selectCommon,
  variables: [{
    key: "labelFontSize",
    defaultUnit: "px"
  }]
});
var CheckboxOption = function CheckboxOption(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: props.isSelected,
    disabled: props.isDisabled
  }), children));
};
CheckboxOption.displayName = "CheckboxOption";
var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: "keyboardArrowDown",
    fill: "highContrast",
    "aria-hidden": "true"
  }));
};
DropdownIndicator.displayName = "DropdownIndicator";
var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-ta-locator": "select-clear-button"
  }, /*#__PURE__*/_react.default.createElement(_reactSelect.components.ClearIndicator, props));
};
ClearIndicator.displayName = "ClearIndicator";
var MenuPortal = function MenuPortal(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(_ThemeProviderWrapper.default, {
    nested: true,
    withGlobalStyles: false
  }, children);
};
MenuPortal.displayName = "MenuPortal";
var SelectInner = function SelectInner(props, ref) {
  var _ref3, _props$disabled;
  var _splitCommonFromProps = (0, _splitCommonFromProps12.default)(props, selectCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    _splitCommonFromProps4 = _splitCommonFromProps3.overrides,
    overrides = _splitCommonFromProps4 === void 0 ? {} : _splitCommonFromProps4,
    _splitCommonFromProps5 = _splitCommonFromProps3.options,
    options = _splitCommonFromProps5 === void 0 ? [] : _splitCommonFromProps5,
    value = _splitCommonFromProps3.value,
    defaultValue = _splitCommonFromProps3.defaultValue,
    _splitCommonFromProps6 = _splitCommonFromProps3.isMulti,
    isMulti = _splitCommonFromProps6 === void 0 ? false : _splitCommonFromProps6,
    _splitCommonFromProps7 = _splitCommonFromProps3.isSearchable,
    isSearchable = _splitCommonFromProps7 === void 0 ? true : _splitCommonFromProps7,
    _splitCommonFromProps8 = _splitCommonFromProps3.hasCheckbox,
    hasCheckbox = _splitCommonFromProps8 === void 0 ? false : _splitCommonFromProps8,
    _splitCommonFromProps9 = _splitCommonFromProps3.isDisabled,
    isDisabled = _splitCommonFromProps9 === void 0 ? false : _splitCommonFromProps9,
    _splitCommonFromProps0 = _splitCommonFromProps3.button,
    initialButton = _splitCommonFromProps0 === void 0 ? null : _splitCommonFromProps0,
    labelText = _splitCommonFromProps3.labelText,
    errorText = _splitCommonFromProps3.errorText,
    _splitCommonFromProps1 = _splitCommonFromProps3.isSelectionVisible,
    isSelectionVisible = _splitCommonFromProps1 === void 0 ? true : _splitCommonFromProps1,
    id = _splitCommonFromProps3.id,
    className = _splitCommonFromProps3.className,
    isAsync = _splitCommonFromProps3.isAsync,
    hint = _splitCommonFromProps3.hint,
    description = _splitCommonFromProps3.description,
    name = _splitCommonFromProps3.name,
    _splitCommonFromProps10 = _splitCommonFromProps3.isClearable,
    isClearable = _splitCommonFromProps10 === void 0 ? false : _splitCommonFromProps10,
    _splitCommonFromProps11 = _splitCommonFromProps3.size,
    size = _splitCommonFromProps11 === void 0 ? "medium" : _splitCommonFromProps11,
    labelFontSize = _splitCommonFromProps3.labelFontSize,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded2);
  process.env.NODE_ENV !== "production" ? (0, _warning.default)(name, "Always add the name prop to input components!") : void 0;
  var icfTheme = (0, _reactJss.useTheme)();
  var classes = (0, _Select2.default)(selectVars.useVars(_objectSpread(_objectSpread({}, common), {}, {
    labelFontSize: labelFontSize
  })));
  var button = initialButton !== null && initialButton !== void 0 ? initialButton : props.flat ? "flat" : null;
  var checkboxMulti = isMulti && hasCheckbox;
  var theme = (0, _Select2.createThemeMapper)(icfTheme, size);
  var selectStyles = (0, _react.useMemo)(function () {
    return (0, _createSelectOverrides.default)(icfTheme, _objectSpread(_objectSpread({}, props), {}, {
      button: button
    }));
  }, [icfTheme, props, button]);
  var inputId = (_ref3 = id !== null && id !== void 0 ? id : name) !== null && _ref3 !== void 0 ? _ref3 : "Select-" + Math.random().toString(36).substr(2, 5);
  var modifiedComponents = {
    ClearIndicator: ClearIndicator,
    DropdownIndicator: DropdownIndicator
  };
  if (checkboxMulti) {
    modifiedComponents.Option = CheckboxOption;
  }
  if (!isClearable) {
    modifiedComponents.IndicatorSeparator = null;
  }
  modifiedComponents.MenuList = function (menuListProps) {
    return /*#__PURE__*/_react.default.createElement(MenuPortal, null, /*#__PURE__*/_react.default.createElement(_reactSelect.components.MenuList, menuListProps));
  };

  /**
   * When the selected options appear as pills in the control box (default for multiselect),
   * we don't need them in the list (highlighted).
   * However, we don't want to hide them if there are checkboxes, because the point of that option
   * is to have some of them checked.
   */
  var hideSelected = isSelectionVisible && props.isMulti && !hasCheckbox;
  var Element = isAsync ? _async.default : _reactSelect.default;
  var extraProps = isAsync ? {
    cacheOptions: props.cacheOptions,
    loadOptions: props.loadOptions
  } : {
    options: (0, _Select.transformOptions)(options)
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.variables, classes.root, overrides.root, className)
  }, labelText && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: inputId,
    className: (0, _classnames.default)(classes.labelText, overrides.labelText)
  }, /*#__PURE__*/_react.default.createElement("span", null, labelText), hint && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.hint)
  }, "\xA0(", hint, ")"), description && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.description)
  }, description)), /*#__PURE__*/_react.default.createElement(Element, _extends({
    menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
    inputId: inputId,
    isDisabled: (_props$disabled = props.disabled) !== null && _props$disabled !== void 0 ? _props$disabled : isDisabled,
    styles: selectStyles,
    isMulti: isMulti,
    isSearchable: button === null && (isSearchable !== null && isSearchable !== void 0 ? isSearchable : props.search),
    defaultValue: (0, _Select.getSelectedOption)(defaultValue, options),
    value: (0, _Select.getSelectedOption)(value, options),
    closeMenuOnSelect: !isMulti,
    components: modifiedComponents,
    theme: theme,
    ref: ref,
    hideSelectedOptions: hideSelected,
    isRtl: icfTheme.direction === _Theme.Direction.rtl,
    controlShouldRenderValue: isSelectionVisible,
    tabSelectsValue: false,
    className: (0, _classnames.default)(classes.select, overrides.select, _defineProperty({}, classes.lightBackground, icfTheme.mode === _Theme.ThemeMode.light)),
    name: name,
    isClearable: isClearable
  }, otherProps, extraProps)), errorText && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(classes.errorText, overrides.errorText)
  }, errorText));
};
SelectInner.displayName = "SelectInner";
var Select = /*#__PURE__*/(0, _react.forwardRef)(SelectInner);
Select.displayName = "Select";
var Storybook = exports.Storybook = Select;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/form-select--docs
 */
var exportedComponent = (0, _defaultProps.default)(Select);
exportedComponent.displayName = "Select";
var _default = exports.default = exportedComponent;